/* ARG HEALTHCARE — cart page. Vanilla JS, no dependencies.
   Quantity, remove + undo, note, discount and mobile checkout bar.
   Every update asks Shopify for this section's HTML only (Section Rendering API). */
(function () {
  'use strict';

  var root = document.querySelector('[data-cxk]');
  if (!root || root.__cxk) return;
  root.__cxk = true;

  var SID = root.getAttribute('data-section');
  var BASE = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MOBILE = window.matchMedia('(max-width: 989px)');
  var toast = root.querySelector('[data-cxk-toast]');
  var bar = root.querySelector('[data-cxk-bar]');
  var live = root.querySelector('[data-cxk-live]');

  var queue = Promise.resolve();
  var inflight = 0;
  var timers = {};      // line key -> { t: timeout, fn: send }
  var undoItem = null;
  var toastTimer, noteTimer, io;

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || root).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); }
  function lines(ctx) { return $$('[data-cxk-line]', ctx).filter(function (l) { return !l.classList.contains('is-out'); }); }
  function lineByKey(key) { return lines().filter(function (l) { return l.dataset.key === key; })[0]; }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function run(task) {
    inflight++;
    root.classList.add('is-sync');
    queue = queue.catch(function () {}).then(task).then(done, function (e) { done(); throw e; });
    return queue;
  }
  function done() {
    inflight--;
    if (!inflight && !Object.keys(timers).length) root.classList.remove('is-sync');
  }

  function api(path, body) {
    return fetch(BASE + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    });
  }
  function withSection(body) {
    body.sections = SID;
    body.sections_url = window.location.pathname;
    return body;
  }

  /* ---------- render server HTML ---------- */
  function swap(sel, fresh) {
    var a = $(sel), b = $(sel, fresh);
    if (a && b) a.replaceWith(b);
    else if (a && !b) a.remove();
  }

  function render(html) {
    if (!html) { window.location.reload(); return; }
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cxk]');
    if (!fresh) { window.location.reload(); return; }

    var count = parseInt(fresh.getAttribute('data-count'), 10) || 0;
    root.setAttribute('data-count', count);

    var list = $('[data-cxk-lines]');
    var flist = $('[data-cxk-lines]', fresh);
    var keys = lines().map(function (l) { return l.dataset.key; }).join('|');
    var fkeys = lines(fresh).map(function (l) { return l.dataset.key; }).join('|');

    if (!list || !flist) {
      // empty <-> filled: swap the whole view
      $('[data-cxk-view]').innerHTML = $('[data-cxk-view]', fresh).innerHTML;
    } else {
      if (keys !== fkeys) {
        if (!$$('.is-out', list).length) list.innerHTML = flist.innerHTML;
      } else {
        lines(fresh).forEach(function (fl) {
          var l = lineByKey(fl.dataset.key);
          if (!l) return;
          ['[data-cxk-unit]', '[data-cxk-ltotal]'].forEach(function (s) {
            var a = $(s, l), b = $(s, fl);
            if (a && b) a.replaceWith(b);
          });
          if (!timers[l.dataset.key]) {
            l.dataset.qty = fl.dataset.qty;
            var input = $('[data-cxk-input]', l);
            if (document.activeElement !== input) input.value = fl.dataset.qty;
            syncStepper(l);
            l.classList.remove('is-busy');
          }
        });
      }
      swap('[data-cxk-summary]', fresh);
      swap('[data-cxk-count]', fresh);
    }

    var bt = $('[data-cxk-bar-total]'), fbt = $('[data-cxk-bar-total]', fresh);
    if (bt && fbt) bt.textContent = fbt.textContent;

    updateBadges(count);
    observeCta();

    var total = $('[data-cxk-total]');
    if (live) live.textContent = count ? 'Cart updated. Total ' + (total ? total.textContent : '') : 'Your cart is empty.';
  }

  /* ---------- header badges ---------- */
  function updateBadges(n) {
    $$('[data-cart-count]', document).forEach(function (e) { e.textContent = n; });
    $$('#site-header a[href$="/cart"], a.mobile-cart-btn', document).forEach(function (a) {
      var b = a.querySelector('.cart-badge');
      if (n > 0) {
        if (!b) {
          b = document.createElement('span');
          b.className = 'cart-badge';
          b.setAttribute('aria-hidden', 'true');
          a.appendChild(b);
        }
        b.textContent = n;
      } else if (b) {
        b.remove();
      }
      a.setAttribute('aria-label', 'View cart, ' + n + (n === 1 ? ' item' : ' items'));
    });
    document.dispatchEvent(new CustomEvent('cart:update:count', { detail: { count: n }, bubbles: true }));
  }

  /* ---------- quantity ---------- */
  function syncStepper(l) {
    var q = $('.cxk-qty', l);
    if (!q) return;
    var v = parseInt($('[data-cxk-input]', l).value, 10) || 0;
    var min = parseInt(q.dataset.min, 10) || 1;
    var max = parseInt(q.dataset.max, 10) || 9999;
    var atMin = v <= min;
    q.classList.toggle('is-min', atMin);
    $('[data-cxk-inc]', l).disabled = v >= max;
    $('[data-cxk-dec]', l).setAttribute('aria-label', atMin ? 'Remove ' + l.dataset.title : 'Decrease quantity');
  }

  function showErr(l, msg) {
    var e = $('[data-cxk-err]', l);
    if (!e) return;
    e.textContent = msg;
    e.hidden = !msg;
  }

  function setQty(l, qty, delay) {
    var q = $('.cxk-qty', l);
    var min = parseInt(q.dataset.min, 10) || 1;
    var max = parseInt(q.dataset.max, 10) || 9999;
    qty = Math.floor(qty);
    if (!(qty >= min)) return removeLine(l);
    var key = l.dataset.key;
    var capped = qty > max;
    if (capped) qty = max;

    // no change (e.g. blur after a capped entry): do nothing, so nothing shifts under the pointer
    if (qty === parseInt(l.dataset.qty, 10) && !timers[key]) {
      $('[data-cxk-input]', l).value = qty;
      syncStepper(l);
      if (capped) showErr(l, 'Only ' + max + ' available.');
      return;
    }
    showErr(l, capped ? 'Only ' + max + ' available.' : '');

    $('[data-cxk-input]', l).value = qty;
    syncStepper(l);
    l.classList.add('is-busy');
    root.classList.add('is-sync');

    if (timers[key]) clearTimeout(timers[key].t);
    var send = function () {
      delete timers[key];
      if (qty === parseInt(l.dataset.qty, 10)) {
        l.classList.remove('is-busy');
        if (!inflight && !Object.keys(timers).length) root.classList.remove('is-sync');
        return Promise.resolve();
      }
      return run(function () {
        return api('cart/change.js', withSection({ id: key, quantity: qty }))
          .then(function (j) { render(j.sections && j.sections[SID]); })
          .catch(function (err) {
            var line = lineByKey(key) || l;
            showErr(line, (err && (err.description || err.message)) || 'Could not update quantity. Try again.');
            $('[data-cxk-input]', line).value = line.dataset.qty;
            syncStepper(line);
            line.classList.remove('is-busy');
          });
      });
    };
    timers[key] = { t: setTimeout(send, delay), fn: send };
  }

  function flushTimers() {
    Object.keys(timers).forEach(function (k) {
      clearTimeout(timers[k].t);
      timers[k].fn();
    });
    return queue.catch(function () {});
  }

  /* ---------- remove + undo ---------- */
  function removeLine(l) {
    if (!l || l.classList.contains('is-out')) return;
    var key = l.dataset.key;
    if (timers[key]) { clearTimeout(timers[key].t); delete timers[key]; }

    var props = {};
    try { props = JSON.parse(l.dataset.props || '{}') || {}; } catch (e) {}
    var item = { id: parseInt(l.dataset.variant, 10), quantity: parseInt(l.dataset.qty, 10) || 1, properties: props };
    if (l.dataset.plan) item.selling_plan = parseInt(l.dataset.plan, 10);

    var hadFocus = l.contains(document.activeElement);
    var started = Date.now();

    l.style.height = l.offsetHeight + 'px';
    void l.offsetHeight;
    l.classList.add('is-out');
    l.style.height = '0px';
    l.setAttribute('aria-hidden', 'true');

    run(function () {
      return api('cart/change.js', withSection({ id: key, quantity: 0 }))
        .then(function (j) {
          return wait(Math.max(0, 300 - (Date.now() - started))).then(function () {
            l.remove();
            render(j.sections && j.sections[SID]);
            undoItem = item;
            showToast('Removed ' + l.dataset.title, true, hadFocus);
          });
        })
        .catch(function () {
          l.classList.remove('is-out');
          l.style.height = '';
          l.removeAttribute('aria-hidden');
          showErr(l, 'Could not remove this item. Try again.');
        });
    });
  }

  function undo() {
    if (!undoItem) return;
    var item = undoItem;
    undoItem = null;
    hideToast();
    run(function () {
      return api('cart/add.js', withSection({ items: [item] }))
        .then(function (j) { render(j.sections && j.sections[SID]); })
        .catch(function (err) {
          showToast((err && err.description) || 'Could not restore the item.', false);
        });
    });
  }

  function showToast(msg, withUndo, focusUndo) {
    if (!toast) return;
    var btn = $('[data-cxk-undo]', toast);
    $('[data-cxk-toast-msg]', toast).textContent = msg;
    btn.hidden = !withUndo;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, withUndo ? 8000 : 4000);
    if (focusUndo && withUndo) btn.focus({ preventScroll: true });
  }
  function hideToast() {
    if (!toast) return;
    clearTimeout(toastTimer);
    toast.classList.remove('is-on');
    undoItem = null;
  }

  /* ---------- note ---------- */
  function saveNote(value) {
    return api('cart/update.js', { note: value }).catch(function () {});
  }

  /* ---------- mobile sticky checkout ---------- */
  function setBar(on) {
    if (!bar) return;
    bar.classList.toggle('is-on', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
    document.body.classList.toggle('cxk-bar-on', on && MOBILE.matches);
  }
  function observeCta() {
    if (!bar) return;
    if (io) io.disconnect();
    var cta = $('[data-cxk-cta]');
    if (!cta || !('IntersectionObserver' in window) || !(parseInt(root.getAttribute('data-count'), 10) > 0)) {
      setBar(false);
      return;
    }
    io = new IntersectionObserver(function (entries) {
      setBar(MOBILE.matches && !entries[0].isIntersecting);
    });
    io.observe(cta);
  }

  function setLoading(on) {
    $$('button[name="checkout"]').forEach(function (b) { b.classList.toggle('is-loading', on); });
  }

  /* ---------- events (delegated: survive re-renders) ---------- */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('button');
    if (!btn || !root.contains(btn)) return;
    var l = btn.closest('[data-cxk-line]');

    if (btn.hasAttribute('data-cxk-inc') && l) {
      setQty(l, (parseInt($('[data-cxk-input]', l).value, 10) || 0) + 1, 350);
    } else if (btn.hasAttribute('data-cxk-dec') && l) {
      setQty(l, (parseInt($('[data-cxk-input]', l).value, 10) || 0) - 1, 350);
    } else if (btn.hasAttribute('data-cxk-remove') && l) {
      removeLine(l);
    } else if (btn.hasAttribute('data-cxk-undo')) {
      undo();
    } else if (btn.hasAttribute('data-cxk-jump')) {
      var sum = $('[data-cxk-summary]');
      if (sum) sum.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  });

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-cxk-input]')) {
      var l = t.closest('[data-cxk-line]');
      var v = parseInt(t.value, 10);
      if (isNaN(v)) { t.value = l.dataset.qty; return; }
      setQty(l, v, 0);
    } else if (t.matches('[data-cxk-terms]') && t.checked) {
      var err = $('[data-cxk-terms-err]');
      if (err) err.hidden = true;
    }
  });

  root.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cxk-note]')) return;
    var val = e.target.value;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { saveNote(val); }, 600);
  });

  // Enter inside quantity / code fields must not submit the checkout form
  root.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t.matches('[data-cxk-input]')) {
      e.preventDefault();
      t.dispatchEvent(new Event('change', { bubbles: true }));
    } else if (t.matches('[data-cxk-code]')) {
      e.preventDefault();
    }
  });

  root.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-cxk-form]')) return;

    var terms = $('[data-cxk-terms]');
    if (terms && !terms.checked) {
      e.preventDefault();
      var err = $('[data-cxk-terms-err]');
      if (err) err.hidden = false;
      terms.scrollIntoView({ behavior: 'smooth', block: 'center' });
      terms.focus({ preventScroll: true });
      return;
    }

    setLoading(true);
    var codeEl = $('[data-cxk-code]');
    var code = codeEl ? codeEl.value.trim() : '';
    if (!code) return; // native POST /cart with name=checkout (apps like COD keep working)

    e.preventDefault();
    var noteEl = $('[data-cxk-note]');
    flushTimers()
      .then(function () { return noteEl ? saveNote(noteEl.value) : null; })
      .then(function () {
        window.location.href = BASE + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(BASE + 'checkout');
      });
  });

  // back button from checkout restores page from bfcache
  window.addEventListener('pageshow', function (e) { if (e.persisted) setLoading(false); });
  if (MOBILE.addEventListener) MOBILE.addEventListener('change', observeCta);

  observeCta();
})();
